export const SHOW_BODY_RISK_MAP = false;
